import React from 'react';
import autobind from 'autobind-decorator';
import FrameMessages from '../const/FrameMessages';
import {getAdHostingWindow} from './utils';

/**
 * [soon deprecated] Iframe Ads usin old AdTemplate configuration
 */
export default class IframeBottomBannerAd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return this.renderCloseAd();
  }

  renderCloseAd() {
    return (
      <a className="vupClosePopup"
         onClick={this.handleClosePopup}>
        {'×'}
      </a>
    );
  }

  @autobind
  handleClosePopup() {
    const {frameId} = this.props;
    getAdHostingWindow().postMessage({title: FrameMessages.requestHide, frameId}, '*');
  }
}
